import React, { useState, useEffect } from 'react';
import ChatBot from './ChatBot';
import FloatingChatButton from './FloatingChatButton';
import { getKnowledgeBases, createKnowledgeBase } from '../../services/knowledgeBaseService';

const ChatBotContainer = ({ knowledgeBaseCode, conversationId, context, onClose }) => {
  const [isChatOpen, setIsChatOpen] = useState(true); // Default to open when used in ActionsSection
  const [actualKnowledgeBaseCode, setActualKnowledgeBaseCode] = useState(knowledgeBaseCode);
  const [isLoading, setIsLoading] = useState(false);

  // Handle KB code resolution
  useEffect(() => {
    const resolveKnowledgeBaseCode = async () => {
      setIsLoading(true);
      try {
        // Check if claim has value_stream
        if (context && context.knowledgebase) {
          setActualKnowledgeBaseCode(context.knowledgebase);
        } else {
          // Query the knowledgebase table and use the first record's code
          const kbResponse = await getKnowledgeBases({}, { created_at: "desc" }, "limit=1");
          
          if (kbResponse && kbResponse.length > 0) {
            // Use the first KB record
            setActualKnowledgeBaseCode(kbResponse[0].code);
            console.log("Using existing KB:", kbResponse[0].code);
          } else {
            // Create a placeholder KB if none exists
            const placeholderKB = {
              name: "placeholder",
              description: "Placeholder knowledge base created automatically",
              code: `KB-${new Date().getTime()}`,
              company_cd: context?.company_cd || "default"
            };
            
            const newKB = await createKnowledgeBase(placeholderKB);
            console.log("Created new placeholder KB:", newKB);
            setActualKnowledgeBaseCode(placeholderKB.code);
          }
        }
      } catch (error) {
        console.error("Error resolving knowledge base code:", error);
        // Fallback to a default KB code format with timestamp
        const fallbackCode = `KB-${new Date().getTime()}`;
        setActualKnowledgeBaseCode(fallbackCode);
      } finally {
        setIsLoading(false);
      }
    };

    resolveKnowledgeBaseCode();
  }, [knowledgeBaseCode, context]);

  const toggleChat = () => {
    setIsChatOpen(!isChatOpen);
  };

  if (isLoading) {
    return (
      <>
        <FloatingChatButton onClick={toggleChat} />
      </>
    );
  }

  return (
    <>
      {/* Only show floating button when used standalone, not when embedded in ActionsSection */}
      {!onClose && <FloatingChatButton onClick={toggleChat} />}
      <ChatBot 
        isOpen={isChatOpen} 
        onClose={() => {
          setIsChatOpen(false);
          // If onClose prop exists, call it when chat is closed
          if (onClose) {
            onClose();
          }
        }} 
        knowledgeBaseCode={actualKnowledgeBaseCode} 
        conversationId={`AH-${conversationId}`}
        context={context}
      />
    </>
  );
};

export default ChatBotContainer;
